import { render, staticRenderFns } from "./AccountResetSubmit.vue?vue&type=template&id=23ac437c&scoped=true"
import script from "./AccountResetSubmit.vue?vue&type=script&lang=js"
export * from "./AccountResetSubmit.vue?vue&type=script&lang=js"
import style0 from "./AccountResetSubmit.vue?vue&type=style&index=0&id=23ac437c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac437c",
  null
  
)

export default component.exports